import gql from 'graphql-tag';

const reviewQuery = gql`
  query {
    IDS_UGCI_PROMO_BANNER_V2: translation(key: "IDS_UGCI_PROMO_BANNER_V2")
    IDS_UGCI_PROMO_BANNER_TITLE_V2: translation(key: "IDS_UGCI_PROMO_BANNER_TITLE_V2")
    IDS_UGC_LEARN_MORE: translation(key: "IDS_UGC_LEARN_MORE")
    IDS_UGC_INCENTIVE_SWITCH: translation(key: "IDS_UGC_INCENTIVE_SWITCH")
    IDS_REVIEWS_BASE_ON_RATINGS: translation(key: "IDS_REVIEWS_BASE_ON_RATINGS")
    IDS_UGC_REVIEW_WRITE_A_REVIEW: translation(key: "IDS_UGC_REVIEW_WRITE_A_REVIEW")
    IDS_FDA_DISCLAIMER: translation(key: "IDS_FDA_DISCLAIMER")
    IDS_UGC_REWARDS_REWARDED_REVIEW: translation(key: "IDS_UGC_REWARDS_REWARDED_REVIEW")
    IDS_UGC_REWARDS_REWARDED_REVIEW_DESC: translation(key: "IDS_UGC_REWARDS_REWARDED_REVIEW_DESC")
    IDS_UGC_QNA_VERIFIED_PURCHASE: translation(key: "IDS_UGC_QNA_VERIFIED_PURCHASE")
    IDS_UGC_HEALTH_CLAIM_DISCLAIMER: translation(key: "IDS_UGC_HEALTH_CLAIM_DISCLAIMER")
    IDS_GEN_DISCLAIMER: translation(key: "IDS_GEN_DISCLAIMER")
    IDS_BTN_REPORT_ABUSE: translation(key: "IDS_BTN_REPORT-ABUSE")
    IDS_UGC_REVIEWS_SHARE_TEXT: translation(key: "IDS_UGC_REVIEWS_SHARE_TEXT")
    IDS_LBL_SEE_ALL_REVIEWS: translation(key: "IDS_LBL_SEE-ALL-REVIEWS")
    IDS_TXT_FEEDBACK_HAS_BEEN_SUBMITTED: translation(key: "IDS_TXT_FEEDBACK_HAS_BEEN_SUBMITTED")
    IDS_UGC_AUTO_TRANSLATED_FROM: translation(key: "IDS_UGC_AUTO_TRANSLATED_FROM")
    IDS_LBL_CUSTOMER_IMAGES: translation(key: "IDS_LBL_CUSTOMER_IMAGES")
    IDS_LBL_REVIEW_IMAGES: translation(key: "IDS_LBL_REVIEW_IMAGES")
    IDS_UGCI_PROMO_DESCRIPTION: translation(key: "IDS_UGCI_PROMO_DESCRIPTION")
    IDS_IDS_UGC_REVIEW_START_REVIEWING: translation(key: "IDS_IDS_UGC_REVIEW_START_REVIEWING")
    IDS_LNK_IHERB_REWARDS: translation(key: "IDS_LNK_IHERB-REWARDS")
    IDS_UGC_QNA_MODAL_SUBMIT: translation(key: "IDS_UGC_QNA_MODAL_SUBMIT")
    IDS_MY_REVIEW_PENDING: translation(key: "IDS_MY_REVIEW_PENDING")
    IDS_UGC_QNA_OKEAY: translation(key: "IDS_UGC_QNA_OKEAY")
    IDS_UGC_REVIEWS_BADGE_TEXT_BRAND: translation(key: "IDS_UGC_REVIEWS_BADGE_TEXT_BRAND")
    IDS_UGC_REVIEWS_BADGE_TEXT_CS: translation(key: "IDS_UGC_REVIEWS_BADGE_TEXT_CS")
    IDS_REVIEWS_BE_THE_FIRST: translation(key: "IDS_REVIEWS_BE_THE_FIRST")
    IDS_REVIEWS_NO_REVIEWED_YET: translation(key: "IDS_REVIEWS_NO_REVIEWED_YET")
    IDS_LBL_EDIT_REVIEW: translation(key: "IDS_LBL_EDIT-REVIEW")
    IDS_UGC_VERIFIED_PURCHASE_REVIEW_DESC: translation(key: "IDS_UGC_VERIFIED_PURCHASE_REVIEW_DESC")
    IDS_UGC_NOT_ELIGIBLE_FOR_REVIEW: translation(key: "IDS_UGC_NOT_ELIGIBLE_FOR_REVIEW")

    IDS_UGC_REPORT_ABUSE_GUIDE: translation(key: "IDS_UGC_REPORT_ABUSE_GUIDE")
    IDS_UGC_REPORT_ABUSE_TOAST_SELECT_REASON: translation(key: "IDS_UGC_REPORT_ABUSE_TOAST_SELECT_REASON")
    IDS_UGC_REPORT_ABUSE_TOAST_ENTER_REASON: translation(key: "IDS_UGC_REPORT_ABUSE_TOAST_ENTER_REASON")
    IDS_UGC_QNA_TEXTAREA_LEAST_CHARACTERS: translation(key: "IDS_UGC_QNA_TEXTAREA_LEAST_CHARACTERS")
    IDS_UGC_QNA_TEXTAREA_MORE_CHARACTERS: translation(key: "IDS_UGC_QNA_TEXTAREA_MORE_CHARACTERS")
    IDS_UGC_REPORT_ABUSE_SUCCESS: translation(key: "IDS_UGC_REPORT_ABUSE_SUCCESS")
    IDS_UGC_REPORT_ABUSE_REPORTED: translation(key: "IDS_UGC_REPORT_ABUSE_REPORTED")
    IDS_UGC_REPORT_ABUSE_WRITE_REASON: translation(key: "IDS_UGC_REPORT_ABUSE_WRITE_REASON")
    IDS_MY_REVIEW_CANCEL_EDIT: translation(key: "IDS_MY_REVIEW_CANCEL_EDIT")
    IDS_MY_REVIEW_UPDATE_MY_REVIEW: translation(key: "IDS_MY_REVIEW_UPDATE_MY_REVIEW")
    IDS_MSG_SHOW_MORE: translation(key: "IDS_MSG_SHOW_MORE")
    IDS_MSG_SHOW_LESS: translation(key: "IDS_MSG_SHOW_LESS")
    IDS_UGC_PENDING_REWARDS_TIP: translation(key: "IDS_UGC_PENDING_REWARDS_TIP")
    IDS_UGC_SUBMITTED_REVIEW_TIP: translation(key: "IDS_UGC_SUBMITTED_REVIEW_TIP")
    IDS_AUTH_CUSTOMER_REVIEWS: translation(key: "IDS_AUTH_CUSTOMER_REVIEWS")
    IDS_BTN_VIEW_ALL_IMAGES: translation(key: "IDS_BTN_VIEW_ALL_IMAGES")
    IDS_UGC_REVIEW_OTHER_IMAGES_IN_REVIEW: translation(key: "IDS_UGC_REVIEW_OTHER_IMAGES_IN_REVIEW")
    IDS_GLOBAL_REVIEWS: translation(key: "IDS_GLOBAL_REVIEWS")
    IDS_LNK_VIEW: translation(key: "IDS_LNK_VIEW")
    IDS_LBL_MOST_HELPFUL_POSI_REVIEW: translation(key: "IDS_LBL_MOST_HELPFUL_POSI_REVIEW")
    IDS_LBL_MOST_HELPFUL_CRIT_REVIEW: translation(key: "IDS_LBL_MOST_HELPFUL_CRIT_REVIEW")
    IDS_LBL_STARS_S: translation(key: "IDS_LBL_STARS_S")
    IDS_LBL_STARS: translation(key: "IDS_LBL_STARS")
    IDS_NOTIFICATION_OKAY: translation(key: "IDS_NOTIFICATION_OKAY")
    IDS_LBL_REVIEWS: translation(key: "IDS_LBL_REVIEWS")
    IDS_MANUFACTURER_RESPONSE_DISCLAIMER: translation(key: "IDS_MANUFACTURER_RESPONSE_DISCLAIMER")
    IDS_UGC_PERIMETERX_IDENTITY_TITLE: translation(key: "IDS_UGC_PERIMETERX_IDENTITY_TITLE")
    IDS_TXT_POSTED_ON: translation(key: "IDS_TXT_POSTED_ON")
    IDS_UGC_UNEXPECTED_ERROR: translation(key: "IDS_UGC_UNEXPECTED_ERROR")
    IDS_LNK_CLOSE: translation(key: "IDS_LNK_CLOSE")
    IDS_AS_SHOW_MORE: translation(key: "IDS_AS_SHOW_MORE")
    IDS_AS_SHOW_LESS: translation(key: "IDS_AS_SHOW_LESS")
    IDS_REVIEW_SUMMARY_CUSTOMERS_SAY: translation(key: "IDS_REVIEW_SUMMARY_CUSTOMERS_SAY")
    IDS_UGC_SUMMARIZATION_TOOLTIP_CONTENT: translation(key: "IDS_UGC_SUMMARIZATION_TOOLTIP_CONTENT")
    IDS_UGC_WRITE_A_REVIEW_GUIDELINES_TITLE: translation(key: "IDS_UGC_WRITE_A_REVIEW_GUIDELINES_TITLE")
    IDS_UGCI_START_REVIEWING: translation(key: "IDS_UGCI_START_REVIEWING")
    IDS_UGC_WRITE_REVIEW_GUIDELINES: translation(key: "IDS_UGC_WRITE_REVIEW_GUIDELINES")
    IDS_UGC_REVIEW_HIGHLIGHTS: translation(key: "IDS_UGC_REVIEW_HIGHLIGHTS")
    IDS_PRODUCT_AUTHENTICITY: translation(key: "IDS_PRODUCT_AUTHENTICITY")
    IDS_UGC_AUTHORIZED_DISTRIBUTORS: translation(key: "IDS_UGC_AUTHORIZED_DISTRIBUTORS")
    IDS_UGC_AUTHORIZED_DISTRIBUTORS_INFO: translation(key: "IDS_UGC_AUTHORIZED_DISTRIBUTORS_INFO")
    IDS_UGC_MORE_OPTIONS: translation(key: "IDS_UGC_MORE_OPTIONS")
    IDS_UGC_SHOW_ORIGINAL_LANGUAGE: translation(key: "IDS_UGC_SHOW_ORIGINAL_LANGUAGE")
    IDS_UGC_SHOW_LANGUAGE: translation(key: "IDS_UGC_SHOW_LANGUAGE")
    IDS_UGC_NOT_FOUND: translation(key: "IDS_UGC_NOT_FOUND")
  }
`;

export default reviewQuery;
